export const FOOD_OFTEN_EAT = [
    "avocado",
    "salmon",
    "blueberries",
    "chicken",
    "greek-yogurt",
    "raspberries",
    "egg",
    "strawberry",
    "quinoa",
    "broccoli",
    "tomato",
    "bell-pepper",
    "asparagus",
    "shrimp",
    "almonds",
    "cucumber",
    "garlic",
    "spinach",
    "feta-cheese",
    "mango",
    "walnuts",
    "pineapple",
    "zucchini",
    "beef"
]
export const FOOD_DISLIKE_EAT = [
    "turkey",
    "tofu",
    "cheese-wedge", // alt="Cheese wedge"
    "salmon",
    "onion",
    "cauliflower",
    "coconut-milk", // alt="Coconut milk"
    "zucchini",
    "brussels-sprouts", // alt="Brussels sprouts"
    "black-olives", // alt="Black olives"
    "radishes",
    "egg",
    "bell-pepper", // alt="Bell pepper"
    "edamame",
    "shrimp",
    "celery",
    "lentils",
    "peas",
    "canned-tuna", // alt="Canned tuna"
    "chia-seeds", // alt="Chia seeds"
    "pumpkin",
    "garlic",
    "spinach",
    "beef",
];

export const SMART_MOBILE_APP_IMAGES = [
    "/static/image/questionnaire/weight-loss/payScreen/ContainerOne@3.png",
    "/static/image/questionnaire/weight-loss/payScreen/ContainerTwo@3.png",
    "/static/image/questionnaire/weight-loss/payScreen/ContainerThree@3.png",
];
export const WEIGHT_LOSS_REAL_USERS_EXPERIENCES_MALE = [{
    image: "/static/image/questionnaire/weight-loss/payScreen/PayMaleWeightLossOne.png",
    content: "I ended up losing 45 pounds—and my beer belly! Dealing with work stress made it really tough to manage my weight. But using Calo to keep track of my eating habits was a game changer. Honestly, I feel so much younger and have way more energy now.",
    name: "-Mark 10/3/2024",
},{
    image: "/static/image/questionnaire/weight-loss/payScreen/PayMaleWeightLossTwo.png",
    content: "As a gym-goer, I always knew that diet was just as important as working out. Calo's precise tracking helped me dial it in. Down 40 lbs and finally seeing my abs, all thanks to Calo's smarts!",
    name: "-Alex  5/13/2025",
},{
    image: "/static/image/questionnaire/weight-loss/payScreen/PayMaleWeightLossThree.png",
    content: "Dropping 50 lbs with Calo reshaped my body and my habits. Thought losing weight was complicated, but Calo made smart eating simple. Highly recommend!",
    name: "-Steve  4/21/2025",
}
];
export const WEIGHT_LOSS_REAL_USERS_EXPERIENCES_FEMALE = [{
    image: "/static/image/questionnaire/weight-loss/payScreen/PayFemaleWeightLossOne.png",
    content: "I used to feel completely lost when it came to dieting, but Calo changed that for me. Its easy-to-use tracking and barcode scanner made things so much simpler, and I ended up losing an incredible 60 pounds! Now I feel fantastic and finally in control of my health.",
    name: "-Emy  4/10/2025",
},{
    image: "/static/image/questionnaire/weight-loss/payScreen/PayFemaleWeightLossTwo.png",
    content: "Wanted to tone up and Calo was perfect. Identifying hidden calories helped me lose 25 lbs and feel healthier than ever. My skin even improved!",
    name: "-Rachel   11/10/2024",
},{
    image: "/static/image/questionnaire/weight-loss/payScreen/PayFemaleWeightLossThree.png",
    content: "This is my first time tracking, and I’ve already lost 7 pounds. Thank you!",
    name: "-Laura 6/12/2025",
}
];

export const CREATING_PLAIN_COMMENT = [{
    content: "Super easy way to track my calories and meals! Love it!!eals! Love it!!",
    name:"- Anna"
},{
    content: "I’ve lost 5 pounds in just one week since I started using this app! Being able to keep track of my calories and monitor my fasting has made such a difference.",
    name:"-Alex"
},{
    content: "Dropping 10 lbs of fat with Calo really brought out my abs. Essential for next-level results!",
    name:"-Emy"
}];

export const HEALTH_CONCERNS = [
    { value: 'Hypertension' },
    { value: 'High cholesterol' },
    { value: 'Obesity' },
    { value: 'Diabetes' },
    { value: 'Heart disease' },
    { value: 'Kidney disease' },
    { value: 'Cancer' },
    { value: 'Lung disease' },
    { value: 'Thyroid disease' },
    { value: 'Gastric disease' }
];
export const DIETARY_PREFERENCE = [
    { content: 'Balanced' },
    { content: 'Low carbs' },
    { content: 'Vegetarian' },
    { content: 'Vegan' },
    { content: 'Mediterranean' },
    { content: 'Paleo' },
    { content: 'High protein' },
    { content: 'Low fat' }
];

export const ACTIVITY_LEVEL = [{
    content: "Sedentary: ",
    value: "Sedentary",
    subcontent: "I sit or lie down most of the day"
},{
    content: "Lightly Active: ",
    value: "Lightly Active",
    subcontent: "I walk or do light chores"
},{
    content: "Moderately Active: ",
    value: "Moderately Active",
    subcontent: "I exercise regularly or move a lot at work"
},{
    content: "Very Active: ",
    value: "Very Active",
    subcontent: "I do physical activities all day"
}];
export const RESULTS_TIMING = [{
    content: "Within a month",
    value: "Within a month"
},{
    content: "1-3 months",
    value: "1-3 months"
},{
    content: "3-6 months",
    value: "3-6 months"
},{
    content: "I am here for the long term",
    value: "I am here for the long term"
}];
export const MEAL_COUNT = [{
    content: "Three meals",
    subcontent: "(breakfast, lunch, dinner)",
},{
    content: "Four meals",
    subcontent: "(breakfast, lunch, dinner, snack)",
}];
export const ALLERGY = [
    { value: 'Gluten' },
    { value: 'Dairy' },
    { value: 'Nut' },
    { value: 'Seafood' },
    { value: 'Egg' }
];